var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnsPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.16667,
    y: 3,
    width: 3.88889,
    height: 14,
    rx: 0.5,
    stroke: "#673E9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.05556,
    y: 3,
    width: 3.88889,
    height: 14,
    rx: 0.5,
    fill: "#D0D2FF",
    stroke: "#673E9B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9444,
    y: 3,
    width: 3.88889,
    height: 14,
    rx: 0.5,
    stroke: "#673E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsPurple);
export default __webpack_public_path__ + "static/media/columns-purple.fb2d02ecc2c1425803b459d26afe2dc9.svg";
export { ForwardRef as ReactComponent };